module.exports = __webpack_public_path__ + "static/media/bluedot.0f7065a2.png";